import apiClient from "@/apiClient";

class ReferenceService {
  id = null;

  constructor(id) {
    this.id = id;
  }

  async get() {
    try {
      return await apiClient.get("/api/reference/" + this.id);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async update(data) {
    try {
      return await apiClient.put("/api/reference/" + this.id + "/manage", data);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async acceptVersion(version_id) {
    try {
      return apiClient.post("/api/reference/" + this.id + "/accepted", {
        version_id: version_id,
      });
    } catch (error) {
      console.log(error)
      throw (error)
    }
  }

  async cancelVersion(version_id) {
    try {
      return apiClient.post("/api/reference/" + this.id + "/cancel", {
        version_id: version_id,
      });
    } catch (error) {
      console.log(error)
      throw (error)
    }
  }

  async destroy(data = {}) {
    try {
      return await apiClient.delete("/api/reference/" + this.id, {
        data,
        suppressAutoReload: true,
        suppressErrorAlert: true,
      });
    } catch (error) {
      console.log(error)
      throw (error)
    }
  }

  async allocateStaff(resource_id, requirement_id, staff_id, options = {}) {
    const { assignmentId = null, ...config } = options;
    var response = await apiClient.post(
      "/api/reference/" + this.id + "/resource/" + resource_id,
      {
        requirement_id,
        staff_id,
        ...(assignmentId ? { assignment_id: assignmentId } : {}),
      },
      config,
    );
    console.log(response)
    return response
  }

  async updateLead(lead_staff_id) {
    return apiClient.put(`/api/reference/${this.id}/lead`, { lead_staff_id });
  }
}
export default ReferenceService;
